module.exports = __webpack_public_path__ + "static/img/rating-D.157d828.png";